export class AdaptiveManager {
    constructor(designWidth = 640, maxWidth = 750, bodyFontSize = '0.16rem') {
        this.designWidth = designWidth;
        this.maxWidth = maxWidth;
        this.bodyFontSize = bodyFontSize;
    }
    calcBaseFontSize() {
        var documentElement = document.documentElement;
        var baseFontSize = Math.min(documentElement.getBoundingClientRect().width, this.maxWidth) / this.designWidth * 100;
        document.documentElement.style.fontSize = baseFontSize + 'px';
        console.log(this.maxWidth)
        document.body.style.fontSize = this.bodyFontSize;
    }
    bindEvents() {
        window.addEventListener('resize', this.calcBaseFontSize.bind(this), false);
    }
    init() {
        this.calcBaseFontSize();
        this.bindEvents();
    }
}

export function checkPermission(permissionList, permissionPath) {
    return permissionList.indexOf(permissionPath) !== -1 || permissionPath === null || permissionPath === undefined;
}

export function checkIndexPermission(permissionList, permissionPath) {
    return permissionList.indexOf(permissionPath) !== -1 || permissionPath === null || permissionPath === undefined;
}
export function encrypt(msg) {
    const CryptoJS = window.CryptoJS;
    var key = CryptoJS.enc.Utf8.parse('2019092415weiyan');
    var iv = CryptoJS.enc.Utf8.parse('weiyan2019092415');
    var passwd = CryptoJS.enc.Utf8.parse(msg.trim());
    const result = CryptoJS.AES.encrypt(passwd, key, {
        iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    return result.ciphertext.toString();
}



// WEBPACK FOOTER //
// ./src/utils/utils.js